module.exports = ".FormContainer{border:1px solid #ededed;border-bottom:none;margin-top:2rem;border-radius:4px;background:#fff}\n"